
/* mobile/tablette : les 4 details techniques passent juste avant les accordeons */
document.addEventListener('DOMContentLoaded',function(){
  var sp=document.querySelector('.pgal .tspecs'),acc=document.querySelector('.pinfo .acc');if(!sp||!acc)return;
  var home=document.createComment('tspecs-home');sp.parentNode.insertBefore(home,sp);
  var mq=matchMedia('(max-width:1100px)');
  function place(){if(mq.matches){if(sp.nextElementSibling!==acc)acc.parentNode.insertBefore(sp,acc);sp.classList.add('ts-mob');}else{if(home.nextSibling!==sp)home.parentNode.insertBefore(sp,home.nextSibling);sp.classList.remove('ts-mob');}}
  place();(mq.addEventListener?mq.addEventListener('change',place):mq.addListener(place));
});
